import { render } from "./App.vue?vue&type=template&id=31fb1317"
const script = {}

import "./App.vue?vue&type=style&index=0&id=31fb1317&lang=css"
script.render = render

export default script